/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

enum EMethod {
    DELETE = "DELETE",
    GET = "GET",
    POST = "POST",
    PUT = "PUT"
}

type MethodKey = keyof typeof EMethod;

export function Fetch(method: MethodKey, url: string, headers?: any, body?: any): Promise<any> {
    return fetch(url, {
        method: method,
        headers: headers,
        body: body
    });
}
export async function FetchJson(method: MethodKey, url: string, headers?: any, body?: any): Promise<any> {
    const response: any = await Fetch(method, url, headers, body);
    return response.json();
}
